import { FC } from 'react';

import { CampaignDeviceType } from 'utils/constants/campaign';

import useTrls from 'hooks/translation/useTrls';

const MobileShows: FC<{
    deviceType: CampaignDeviceType;
}> = ({ deviceType }) => {
    const trl = useTrls();

    return deviceType === CampaignDeviceType.Mobile ? <p>{trl('campaign.targetings.sources.mobileOnly')}</p> : null;
};

export default MobileShows;
